module.exports = {
      id: "photographer-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#photographer",
      toString: function () {
        return this.url;
      }
    }